module.exports = {"meta":{"lead":"The framasoft laboratory"}};